import {
    Dic
} from '$utils'
import {
    lastIndexOf
} from 'lodash'
const tableOption = function (that) {
    return {
        add: '新增',
        edit: '修改',
        view: '详情',
        page: true,
        selection: true,
        index: false,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        align: 'left',
        size: 'small',
        maxHeight: '100%',
        labelWidth: '120px',
        menuAlign: 'center',
        addformslot: true,
        searchMenuSpan: 8,
        searchBtn: false,
        dialogHeight: 200,
        dialogWidth: '750px',
        emptyText: '暂无数据',
        column: [{
                label: '探测器数据地址',
                prop: 'thirdDeviceId',
                viewDisplay: true,
                overHidden: true,
                span: 12,
                // columnWidth: 150,

                formatter: function (row, value) {
                    let index = value.indexOf('-')
                    return value.slice(index + 1)
                },
                viewFormatter: (row, value) => {

                    let str = ''
                    if (value) {
                        let index = value.indexOf('-')
                        str = value.slice(index + 1)
                    }
                    return value ? str : ''


                },
            },
            {
                label: '探测器名称',
                prop: 'deviceName',
                viewDisplay: true,
                overHidden: true,
                span: 12,
                // columnWidth: 10,
                search: true,
            },
            {
                label: '低阈值',
                prop: 'deviceExtendInfoMap',
                viewDisplay: true,
                overHidden: true,
                span: 12,
                formslot: true,
                // columnWidth: 150,
                formatter: function (row, value) {
                    return value.lowThreshold || ''
                },
                viewFormatter: (row, value) => {
                    return value ? value.lowThreshold || '' : ''
                },

            },
            {
                label: '高阈值',
                prop: 'deviceExtendInfoMap',
                viewDisplay: true,
                overHidden: true,
                span: 12,
                formslot: true,
                formatter: function (row, value) {
                    return value.highThreshold || ''
                },
                viewFormatter: function (row, value) {
                    return value ? value.highThreshold || '' : ''
                },

            },
            {
                label: '测量介质',
                prop: 'deviceExtendInfoMap',
                viewDisplay: true,
                overHidden: true,
                span: 12,
                formslot: true,
                formatter: function (row, value) {
                    return value.measureMedium || ''
                },
                viewFormatter: (row, value) => {
                    return value ? value.measureMedium || '' : ''
                },

            },
            {
                label: '介质属性',
                prop: 'subTypeMark',
                viewDisplay: true,
                overHidden: true,
                span: 12,
                type: 'select',
                dicData: Dic.find('SENU110'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU110', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU110', value) : ''
                },


            },
        ]
    }
}
export default tableOption